import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import Mission from "./components/Mission";
import Features from "./components/Features";
import Activities from "./components/Activities";
import Facilities from "./components/Facilities";
import Members from "./components/Members";
import JoinProcess from "./components/JoinProcess";

const AboutPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-16">
				<h1 className="text-4xl font-bold text-center mb-12">
					大船渡学習ギルドについて
				</h1>
				<Mission />
				<Features />
				<Activities />
				<Facilities />
				<Members />
				<JoinProcess />
			</div>
		</Layout>
	);
};

export default AboutPage;
